// Source: CloudSection. Values include intentional inline spacing.
const en = {
  "s1": "Open lakehouse storage (DuckLake)",
  "s2": "Any cloud, any region",
  "s3": "SQL editor in the browser",
  "s4": "Python notebooks",
  "s5": "Load data with native ADBC drivers",
  "s6": "Roles, SSO & audit trail",
  "heading": "Everything your data team needs, fully managed",
  "intro": "The best way to run Hardcharger: launch a managed server in one click on AWS, Google Cloud or Azure, with open lakehouse storage, a browser SQL editor, and the roles, SSO and audit trail your team needs, from one control plane.",
  "shotUrl": "app.gizmodata.com",
  "shotAlt": "GizmoData Cloud compute page: clusters in one environment across Google Cloud, AWS and Azure",
  "seeAll": "See everything GizmoData Cloud does",
  "s14": "Need it inside your own cloud account? ",
  "s15": "Cloud at Customer",
  "s16": " is in production today."
};
const pt: typeof en = {
  "s1": "Armazenamento lakehouse aberto (DuckLake)",
  "s2": "Qualquer nuvem, qualquer região",
  "s3": "Editor SQL no navegador",
  "s4": "Notebooks Python",
  "s5": "Carregue dados com drivers ADBC nativos",
  "s6": "Papéis, SSO e trilha de auditoria",
  "heading": "Tudo o que sua equipe de dados precisa, totalmente gerenciado",
  "intro": "A melhor forma de executar o Hardcharger: inicie um servidor gerenciado com um clique na AWS, no Google Cloud ou no Azure, com armazenamento lakehouse aberto, um editor SQL no navegador e os papéis, o SSO e a trilha de auditoria de que sua equipe precisa, em um único plano de controle.",
  "shotUrl": "app.gizmodata.com",
  "shotAlt": "Página de computação do GizmoData Cloud: clusters em um só ambiente, no Google Cloud, na AWS e no Azure",
  "seeAll": "Veja tudo o que o GizmoData Cloud faz",
  "s14": "Precisa dele dentro da sua própria conta de nuvem? ",
  "s15": "Cloud at Customer",
  "s16": " já está em produção."
};
export default { en, 'pt-BR': pt };
